import { clientPublic, clientPublicService, clientPublicV2 } from "helper/axios";
import { handleError } from "helper/rest";
import get from "lodash/get";
import { encodeId } from "../../helper/sqids";

export const projectInit = async ({ token }) => {
  try {
    return await clientPublicService
      .post(
        "/core/legacy/project/init",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const projectEdit = async ({ params, token }) => {
  try {
    return await clientPublicService
      .put(`/core/legacy/project/${encodeId(params.initId)}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const getProjectById = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(`project/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const saveImage = async ({ params, token }) => {
  try {
    return await clientPublic
      .post("project/image", params, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const saveDoucment = async ({ params, token }) => {
  try {
    return await clientPublic
      .post("project/image", params, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const projectCopy = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.id}/copy`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const deleteProject = async ({ project_id, token }) => {
  try {
    return await clientPublicV2
      .delete(`project/${project_id}/delete`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

// show file document and picture

export const getFilelist = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(`itemdocument?project_id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};
//get File Doc : 13
export const getFileDoc = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(`itemdocument?project_id=${params.id}&kind=${params.kind}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const deleteFile = async ({ params, token }) => {
  try {
    return await clientPublic
      .delete(
        `itemdocument/${params.id}?project_id=${params.project_id}&kind=${params.kind}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};
export const deleteFile_ALL = async ({ params, token }) => {
  try {
    return await clientPublic
      .delete(
        `itemdocument/all?project_id=${params.project_id}&kind=${params.kind}&sprintflow_id=${params.sprintflow_id}&task_id=${params.task_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const deleteEventChangeCompany = async ({ params, token }) => {
  try {
    return await clientPublic
      .delete(`project/${params.project_id}/chgcomp`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};
